export default __webpack_public_path__ + "static/media/exclamation.60d5a431.gif";